import React from 'react';
import InputMask from 'react-input-mask';

class InputPhone extends React.Component {
    state = {
        value: ''
    };

    componentDidMount() {
        this.setState({ value: this.props.value });
    }

    onChange = (e) => {
        this.setState({ value: e.target.value }, () => {
            this.props.onChange(this.state.value);
        });
    };

    render() {
        let mask = null;
        const val = this.state.value ? this.state.value : "";
        if(val){
            mask = "(999) 999-9999";
        }
        return <InputMask className="form-control" mask={mask} value={val} onChange={this.onChange} required={this.props.required} />;
    }
}

export default InputPhone;